import React, { useState } from 'react';
import { useRouter } from 'next/router';
import {
  HeaderV2,
  Segment,
  useEnvironmentConfig,
} from '@sparknz/journeys-common';
import { trackCustomLink } from '@sparknz/tracking';

import { HeaderContentQuery$data } from '__generated__/HeaderContentQuery.graphql';
import { CONTENT_ID, VARIATION } from 'shared/constants/content.constant';
import { CART_PAGE } from 'shared/constants/paths.constants';
import { getPath } from 'shared/utils';
import { useSegment } from '../../hooks';
import { environmentVariables } from '../../utils/environment.utils';

interface HeaderProps {
  showCart?: boolean;
  showSearch?: boolean;
  onLogout?: () => void;
  content?: HeaderContentQuery$data;
}

const Header = ({ showCart, onLogout }: HeaderProps) => {
  const config = useEnvironmentConfig();
  const { segment, channel } = useSegment();
  const { cartCookieName } = config;
  const [isMinicartOpen, setIsMinicartOpen] = useState(false);
  const { push } = useRouter();

  const handleMinicartClose = () => {
    setIsMinicartOpen(false);
  };

  const handleMinicartClick = () => {
    trackCustomLink('Minicart click');
    setIsMinicartOpen((prevState) => !prevState);
  };

  const handleGoToCartClick = () => {
    push(getPath(CART_PAGE, channel));
  };

  return (
    <HeaderV2
      apiBaseUrl={environmentVariables?.apiURL}
      contentId={CONTENT_ID[segment as Segment]}
      modelVariation={VARIATION[segment as Segment]}
      cartCookieName={cartCookieName}
      signInURL={environmentVariables?.signInURL}
      handleMinicartClick={handleMinicartClick}
      onLogout={onLogout}
      showCart={showCart}
      isMinicartOpen={isMinicartOpen}
      handleMinicartClose={handleMinicartClose}
      handleGoToCartClick={handleGoToCartClick}
      shouldDisplayRemoveButton
    />
  );
};

export default Header;
